import { useUserStore } from '../stores/useUserStore';
import { useAudioStore } from '../stores/useAudioStore';
import { useDressStore } from '../stores/useDressStore';
import { useRestStore } from '../stores/useRestStore';
import { useSettingsStore } from '../stores/useSettingsStore';
import { useTodoStore } from '../stores/useTodoStore';

// 別ウィンドウ（Electronのマスコット⇔メインアプリ）やブラウザの別タブが
// localStorageに書き込んだ変更を、storageイベント経由で自分のストアへ反映する。
//
// usePomodoroStore（sorarium-pomodoro-storage）は意図的に対象外:
// rehydrate時のonRehydrateStorageがcurrentSessionをリセットするため、
// 同期すると実行中のタイマーが巻き添えで止まる。作業ログは次回起動時に揃う。
const SYNC_TARGETS = {
  'sorarium-user-storage': useUserStore,
  'sorarium-audio-storage': useAudioStore,
  'sorarium-dress-storage': useDressStore,
  'sorarium-rest-storage': useRestStore,
  'sorarium-settings': useSettingsStore,
  'sorarium-todo-storage': useTodoStore,
} as const;

export function initCrossWindowSync() {
  window.addEventListener('storage', (e) => {
    if (!e.key || !(e.key in SYNC_TARGETS)) return;
    SYNC_TARGETS[e.key as keyof typeof SYNC_TARGETS].persist.rehydrate();
  });
}
